document.addEventListener('DOMContentLoaded', function() {
  const wrappers = document.querySelectorAll('.rich-text-wrapper');
  
  wrappers.forEach(function(wrapper) {
    const content = wrapper.querySelector('.rich-text-content');
    const button = wrapper.querySelector('.read-more-btn');
    
    if (!content || !button) return;
    
    // Vänta lite så att innehållet hinner renderas
    setTimeout(function() {
      const maxHeight = 150; // Samma som i CSS
      
      if (content.scrollHeight > maxHeight + 20) {
        content.classList.add('collapsed');
        button.style.display = 'inline-block';
        
        button.addEventListener('click', function() {
          if (content.classList.contains('collapsed')) {
            content.style.maxHeight = content.scrollHeight + 'px';
            content.classList.remove('collapsed');
            button.textContent = 'Read less';
          } else {
            content.style.maxHeight = '';
            content.classList.add('collapsed');
            button.textContent = 'Read more';
          }
        });
      }
    }, 100);
  });
});
